/* eslint camelcase: 0 */

import cs_cs from './cs-cs';
import de_at from './de-at';
import de_de from './de-de';
import el_gr from './el-gr';
import en_ca from './en-ca';
import en_gb from './en-gb';
import en_ie from './en-ie';
import es_es from './es-es';
import fi_fi from './fi-fi';
import fr_fr from './fr-fr';
import hu_hu from './hu-hu';
import it_it from './it-it';
import ja_jp from './ja-jp';
import pl_pl from './pl-pl';
import pt_pt from './pt-pt';
import ro_ro from './ro-ro';
import ru_ru from './ru-ru';
import sl_sl from './sl-sl';
import sr_sr from './sr-sr';
import sv_se from './sv-se';
import zh_cn from './zh-cn';
import zh_hk from './zh-hk';

export const transformLangCode = (activeLangCode: string) => (
    activeLangCode.replace('-', '_').toLocaleLowerCase() || 'en_en'
);

export default {
    cs_cs,
    de_at,
    de_de,
    el_gr,
    en_ca,
    en_gb,
    en_ie,
    es_es,
    fi_fi,
    fr_fr,
    hu_hu,
    it_it,
    ja_jp,
    pl_pl,
    pt_pt,
    ro_ro,
    ru_ru,
    sl_sl,
    sr_sr,
    sv_se,
    zh_cn,
    zh_hk,
};



// WEBPACK FOOTER //
// ./src/main/translations/index.js